import axios from 'axios';

export const fetchSessionData = async (apiToken) => {
    try {
        const apiUrl = process.env.REACT_APP_API_URL;
        const response = await axios.get(`${apiUrl}/session`, { headers: { Authorization: apiToken } });

        // Assuming the response structure is as you described
        const sessionData = {
            userGroups: response.data.data.userGroups,
        };

        return sessionData;
    } catch (error) {
        console.error('Error fetching session data', error);
        // Handle the error appropriately - you might want to throw it, 
        // return null, or return an error object depending on your UI's needs
        return null; // Example
    }
};
